import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-regulamento {
  padding: 24px 0 40px;
  background: #fff;
  text-align: left;
}

#partiu-gp-regulamento .ctn-home-24 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#partiu-gp-regulamento .eyebrow {
  margin: 0 0 4px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
}

#partiu-gp-regulamento .titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
}

#partiu-gp-regulamento .texto {
  margin: 0 0 24px;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
}

#partiu-gp-regulamento .actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  justify-content: space-between;
}

#partiu-gp-regulamento .btn-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 32px;
  border-radius: 999px;
  border: 1px solid #ec0000;
  background: #fff;
  color: #ec0000;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 350ms linear;
}

#partiu-gp-regulamento .btn-outline:hover {
  background-color: #ffeaea;
}

#partiu-gp-regulamento .link {
  color: #127277;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: underline;
}

#partiu-gp-regulamento .disclaimer {
  margin: 0;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
}

@media (min-width: 992px) {
  #partiu-gp-regulamento {
    padding: 40px 0;
    text-align: center;
  }

  #partiu-gp-regulamento .ctn-home-24 {
    align-items: center;
  }

  #partiu-gp-regulamento .eyebrow {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  #partiu-gp-regulamento .titulo {
    margin: 0 0 28px;
    font-size: 48px;
    line-height: 56px;
  }

  #partiu-gp-regulamento .texto {
    font-size: 18px;
    line-height: 28px;
  }

  #partiu-gp-regulamento .actions {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
`;

export default styles;